import { ErrorMessageWrapper } from 'ui/forms';
import { KoobInputStepper } from '@koob/ui';
import { useField } from 'formik';
import VisuallyHidden from 'components/VisuallyHidden';
import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';

const DisplayLabel = styled.span.attrs({ 'aria-hidden': true })`
  font-weight: 600;
`;

const FormInputWrapper = ({
  children,
  label,
  beforeLabel,
  afterLabel,
  id,
  kind,
  required,
}) => (
  <>
    <VisuallyHidden as={'label'} for={id}>
      {label}
    </VisuallyHidden>
    <DisplayLabel>
      {beforeLabel}
      {required && <span className="ml-1 text-red-500">*</span>}
    </DisplayLabel>
    {children}
    <DisplayLabel>{afterLabel}</DisplayLabel>
  </>
);

const PromotionsNightsNumberField = ({
  kind,
  name,
  required,
  touchRequired = true,
}) => {
  const theme = useTheme();
  const { t } = useTranslation('promotionForm');

  const [field, meta, helpers] = useField(name);
  if (!kind) return null;
  const id = `${kind}_guests`;
  const hasError =
    (!touchRequired || Boolean(meta.touched)) && Boolean(meta.error);

  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        <FormInputWrapper
          kind={kind}
          id={id}
          label={t(`nightsContraints.${kind}.label`)}
          beforeLabel={t(`nightsContraints.${kind}.splittedLabel.before`)}
          afterLabel={t(`nightsContraints.${kind}.splittedLabel.after`)}
          required={required}
        >
          <span
            style={{
              marginInline: theme.spacing(0.375),
              display: 'inline-flex',
            }}
          >
            <KoobInputStepper
              id={id}
              name={field.name}
              min={0}
              error={hasError}
              value={field.value ?? null}
              onValueChange={helpers.setValue}
              onBlur={field.onBlur}
            />
          </span>
        </FormInputWrapper>
      </div>
      {hasError && (
        <ErrorMessageWrapper style={{ marginTop: theme.spacing(0.25) }}>
          {t('errors:required')}
        </ErrorMessageWrapper>
      )}
    </div>
  );
};

export default memo(PromotionsNightsNumberField);
